module.exports = __webpack_public_path__ + "img/icon-request.277a8d1f.svg";